var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDhlLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 196,
    height: 43.2533,
    viewBox: "0 0 196 43.2533",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n  DHL_rgb\n ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 43.2533,
    fill: "#fc0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0 29.901 26.506 29.901 25.058 31.871 0 31.871 0 29.901 0 29.901",
    fill: "#d40511"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 26.245 29.199 26.245 27.748 28.213 0 28.213 0 26.245 0 26.245",
    fill: "#d40511"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 33.56 23.815 33.56 22.373 35.516 0 35.516 0 33.56 0 33.56",
    fill: "#d40511"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "196 31.871 169.598 31.871 171.045 29.902 196 29.902 196 31.871 196 31.871",
    fill: "#d40511"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196 35.516 166.913 35.519 168.354 33.56 196 33.56 196 35.516 196 35.516",
    fill: "#d40511"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.735 26.245 196 26.245 196 28.214 172.287 28.216 173.735 26.245 173.735 26.245",
    fill: "#d40511"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.6726,35.5163,38.2505,18.4275H53.8587c1.7252,0,1.7026.655.86,1.7975-.8562,1.16-2.3133,3.1547-3.1854,4.3323-.4426.5982-1.2431,1.6881,1.4089,1.6881h20.91c-1.739,2.3822-7.38,9.2709-17.5082,9.2709Z",
    fill: "#d40511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7056,26.244l-6.82,9.2723H72.893s6.8172-9.2709,6.8233-9.2709l17.9893-.0014Z",
    fill: "#d40511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.7239,26.2454,116.9,35.5163H98.9143s6.8178-9.2709,6.8239-9.2709Z",
    fill: "#d40511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5749,26.2454c.0006,0-1.3141,1.7975-1.9529,2.66-2.2593,3.0534-.2626,6.6105,7.111,6.6105h28.8853l6.8226-9.2709Z",
    fill: "#d40511"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.4685,7.8007l-6.2621,8.508H62.3353c1.7249,0,1.7023.655.8592,1.7974-.8562,1.1587-2.2894,3.1763-3.1614,4.3539-.4427.597-1.2432,1.6867,1.4089,1.6867H75.3984s2.25-3.0615,4.1352-5.6206c2.5655-3.4815.2225-10.7254-8.9486-10.7254Z",
    fill: "#d40511"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.269 24.147 81.262 24.147 93.296 7.801 111.282 7.801 104.386 17.173 112.414 17.173 119.315 7.801 137.299 7.801 125.269 24.147 125.269 24.147",
    fill: "#d40511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.2084,7.8007,150.177,24.1467H131.1177s12.0355-16.346,12.0415-16.346Z",
    fill: "#d40511"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhlLogo);
export default __webpack_public_path__ + "static/media/dhl-logo.8824fcafd1f930b5e7e69161673d5807.svg";
export { ForwardRef as ReactComponent };